import { render, staticRenderFns } from "./ratings-candidate.vue?vue&type=template&id=4953cd6c"
import script from "./ratings-candidate.vue?vue&type=script&lang=js"
export * from "./ratings-candidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports